import { ValuableModel } from '../../models/ValuableModel'

export class SchemaAnyModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Any': SchemaAnyModel
  }
}
